import type { School } from '@whizz/api-model';
import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import type { UseQueryResult } from 'react-query';
import { model } from '@whizz/api-client';
import { useIdentity } from '@whizz/react-identity';
import { useQuery } from 'react-query';
import { QUERIES_IDS } from '../util/vars';

// implementationPlanEnabled and impactReportScheduleEnabled are added by the api's school info.
type SchoolInfo = School & { implementationPlanEnabled?: boolean; impactReportScheduleEnabled?: boolean };

// The school's details from the api. The header and the implementation plan route share this one request.
export const useSchoolInfo = (schoolId?: number | null): UseQueryResult<SchoolInfo | null> => useQuery(
  [ QUERIES_IDS.SCHOOL_INFO, schoolId ],
  () => (schoolId ? model.School.get(schoolId) : null),
  { enabled: !!schoolId },
);

// Whether the signed-in teacher's school has the implementation plan; the api decides by the school's country.
export const useImplementationPlanEnabled = (): { isEnabled: boolean; isLoading: boolean } => {
  const { me } = useIdentity();
  const school = useSchoolInfo((me as Teacher)?.getSchoolId());

  return { isEnabled: !!school.data?.implementationPlanEnabled, isLoading: school.isLoading };
};
